<template>
  <div>
    <AlertDismiss ref="alertDismiss"></AlertDismiss>

    <b-pagination v-model="filter.page" :total-rows="rows" :per-page="filter.pageSize"
                  aria-controls="table-list-document" class="m-2" pills>
    </b-pagination>
  </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'

export default {
  name: 'KarinNotificationPagination',

  data() {
    return {
      filter: {
        page: 1,
        pageSize: InitPageSize.KarinNotificationPageSize
      },

      rows: 0
    }
  },

  async mounted() {

    await this.getCount()
    
    await this.paginationFilter()

  },

  components: {
    AlertDismiss
  },

  methods:{
    ...mapActions(["countKarinNotification"]),

    paginationFilter() {
      this.$eventBus.$emit(EventNames.PaginationFilterKarinNotification, this.filter);
    },

    async getCount() {
      let result = await this.countKarinNotification(this.filter);
      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message);
        return;
      }

      this.rows = result.data;
    }
  },

  watch: {
    //cada ves que se haga un click al paginador entonces emite el evento
    async "filter.page"() {
      this.paginationFilter();
    },
  }

}
</script>
<style>

</style>
